import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LookupModel } from '../../../../api/models';
import {
  EVENT_FILTER_OPTIONS,
  UNIQUE_FILTER_LABELS,
} from '../../node-parameters/constants/events-filter-options.const';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { INodeViewModel } from '../../../../core/visual/work-flow-editor/models/i-node-view-model';
import { EventsFlowDataFormService } from '../../../services/events-flow-data-form.service';
import { EVENT_FILTER_SELECT_VALUES } from '../../node-parameters/constants/event-filter-select-options';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor } from '@angular/common';
import { MatSimpleSelectComponent } from '../../../../editors/mat-simple-select/mat-simple-select.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMultiselectComponent } from '../../../../editors/mat-multiselect-input/mat-multiselect.component';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'events-flow-event-filters',
    templateUrl: './event-filters.component.html',
    styleUrls: ['./event-filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatSimpleSelectComponent,
        FormsModule,
        MatButton,
        NgFor,
        MatMultiselectComponent,
        ReactiveFormsModule,
        MatIconButton,
        MatIcon,
    ],
})
export class EventFiltersComponent {
  @Input({ required: true })
  node: INodeViewModel<any>;

  public filterSelect: string;

  public readonly UNIQUE_FILTER_LABELS = UNIQUE_FILTER_LABELS;

  constructor(private readonly _eventsFlowDataFormService: EventsFlowDataFormService) {}

  get eventFlowFilterGroups(): FormGroup[] {
    return [...this._eventsFlowDataFormService?.eventsFlowFiltersForm.controls] as FormGroup[];
  }

  public getSelectValues(filterKey: string): LookupModel[] {
    return EVENT_FILTER_SELECT_VALUES[filterKey] || null;
  }

  public getFilterOptions(eventType: string): LookupModel[] {
    const alreadySelectedFilters = new Set(this.eventFlowFilterGroups.map(control => control.get('key')?.value));

    return (EVENT_FILTER_OPTIONS[eventType] || []).filter(option => !alreadySelectedFilters.has(option.id as string));
  }

  public onAddFilter(): void {
    this._eventsFlowDataFormService.addEventFlowEventFilter(this.filterSelect);
    this.filterSelect = null;
  }

  public onRemoveFilter(index: number): void {
    this._eventsFlowDataFormService.removeEventFlowEventFilter(index);
  }
}
